import { message,Select } from "antd";
import React, { useEffect, useState } from "react";
import { useCommonStore } from "@/store/useCommonStore";
import _ from "lodash";


const { Option } = Select;

const IdTypeSelect = (props) => {
    const { value, onChange } = props;
    const sysdicts = useCommonStore.use.sysdicts();
    const item = _.find(sysdicts,(item)=>item.Name == "IDTypes");
    const data = item.Data;
    const dealValues = (value) => {
        if (value) {
            onChange(value);
            let valueItem = data.find(item=>item.code == value);
            if(!valueItem) return value;
            return valueItem.name;
        }
    }

    const changevalue = dealValues(value);

    const handleChange = value => {
        if(onChange) onChange(value);
      };
    const options = data.map(d => {
        
        return <Option key={d.code}>{d.name}</Option>}
    );
    console.log(data);
    return (<Select
        placeholder="请选择证件类型..."
        //mode="multiple"
        defaultValue={changevalue}
        onChange={handleChange}
    >
        {options}
    </Select>);
}

export default IdTypeSelect;